export const Ph = ({ children }) => <span className="lg-ph">{children}</span>;

export const Term = ({ children }) => <span className="lg-term">{children}</span>;

export const LeadIn = ({ children }) => (
  <span className="lg-lead-in">{children}</span>
);

export const Clause = ({ n, children }) => (
  <div className="lg-clause">
    <i>{n}</i>
    <div>{children}</div>
  </div>
);

export const Callout = ({ title, children }) => (
  <div className="lg-callout">
    <p>
      <LeadIn>{title}</LeadIn>
      {children}
    </p>
  </div>
);

export const DataTable = ({ head, rows }) => (
  <div className="lg-tablewrap">
    <table>
      <thead>
        <tr>
          {head.map((cell) => (
            <th key={cell}>{cell}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <td key={cellIndex}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const Plain = ({ items }) => (
  <ul className="lg-plain">
    {items.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ul>
);

export const Pill = ({ required, children }) => (
  <span className={required ? "lg-pill lg-pill-req" : "lg-pill"}>{children}</span>
);

export const Lettered = ({ items }) => (
  <ol className="lg-lettered">
    {items.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ol>
);

export const Glance = ({ items }) => (
  <div className="lg-glance">
    <p className="lg-glance-head">At a glance</p>
    <dl>
      {items.map(([term, detail]) => (
        <div key={term}>
          <dt>{term}</dt>
          <dd>{detail}</dd>
        </div>
      ))}
    </dl>
  </div>
);

export const Heading = ({ children }) => <h3>{children}</h3>;
